import { Grid, Typography, Box } from "@mui/material";
import React from "react";

const informationData = [
  {
    id: 1,
    name: "Tell us about your business",
    description:
      "Share some basic info, like your venue name, location and opening hours",
  },
  {
    id: 2,
    name: "Stand out online",
    description:
      "Add images of your location and select some venue highlights to make your profile pop",
  },
  {
    id: 3,
    name: "Accept online bookings",
    description:
      "With a complete profile you're ready to start taking online bookings directly and on the Loba marketplace",
  },
];

const ShowCaseTwo = () => {
  return (
    <Grid
      spacing={4}
      container
      sx={{ alignItems: "center", justifyContent: "center", marginTop: "40px" }}
    >
      <Grid item xs={12} sm={6} md={4.5}>
        <Typography variant="h3" sx={{ fontWeight: "700", fontSize: "15px" }}>
          Step 3
        </Typography>
        <Typography
          variant="h3"
          sx={{ fontWeight: "700", fontSize: "35px", margin: "12px 0" }}
        >
          Accept online bookings on Loba Marketplace
        </Typography>
        <Typography
          variant="h3"
          sx={{ fontWeight: "400", fontSize: "14px", lineHeight: "22px" }}
        >
          With a complete profile you're ready to start taking online bookings
          directly and on the Loba marketplace
        </Typography>
      </Grid>
    </Grid>
  );
};

export default ShowCaseTwo;
